// -----------------------------------
// YouTube Embed
// -----------------------------------
;(function(window, document){
	var videoBox = $('.video-box');

	if(videoBox.length === 0) return false;

	var youTubeSetting = '?rel=0&modestbranding=1&autoplay=1&version=3&enablejsapi=1';

	var videoIframe = null;

	// Each Video
	videoBox.each(function(){
		var currentItem = $(this);
		var youTubeUrl = currentItem.attr('data-video');
		var youTubeId = getYoutubeId(youTubeUrl);

		// 寫入Properties
		this.videoId = youTubeId;

		var videoImg = currentItem.children('.video-embed');
		var videoPlay = currentItem.children('[data-video-play]');

		var videoIframeSrc = 'https://www.youtube.com/embed/' + youTubeId + youTubeSetting;
		var youTubeIframeString ='<iframe width="560" height="315" class="video-player" title="Video Player" src="'+videoIframeSrc+'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

        var videoCover = currentItem.data('video-cover');
        
		// Video Img
		if(videoCover != false){
			// 配合Swiper lazyloading
			if(videoImg.hasClass('swiper-lazy') || videoImg.hasClass('lazy')){
				// 有 => 增加於Attribute
				videoImg.attr({
					'data-background': 'https://img.youtube.com/vi/'+ youTubeId +'/0.jpg'
				});
			}else{
				videoImg.css({
					'background-image': 'url(https://img.youtube.com/vi/'+ youTubeId +'/0.jpg)'
				});
			}

		}

		// Click and load iframe
		videoPlay.on('click', function(){
			currentItem.append(youTubeIframeString);
			currentItem.addClass('is-loaded');

			videoIframe = currentItem.get(0).querySelector('.video-player');
			$(videoIframe).on('load', function(){
				setTimeout(function(){
					youTubePlay(videoIframe);
				}, 1000);
			});
		});
	});

	// 如果使用Lightbox關閉 => 停止播放
	// Pause Video Modal
	// Used page: About, Media Center
	var videoModalCloseClick = false;
	
	$('.video-modal-close').on('click', function(){
		var videoModalIframe = $('.video-modal').find('iframe')[0];
		if(videoModalIframe != undefined){
			youTubeStop(videoModalIframe);
			videoModalCloseClick = true;

			// 尚未讀取完就關閉
			$('.video-modal').find('iframe')[0].onload = function(){
				setTimeout(function(){
					if(videoModalCloseClick){
						youTubeStop(videoModalIframe);
					}
				},2000);
			}
		}
	});
	
	// 如果Modal開啟就還原FLASE
	$('[data-modal]').on('click', function(){
		videoModalCloseClick = false;
	});

	// ---------------------------------------------------------------
	// 讀取網址
	// get-youtube-info.js: https://gist.github.com/ramonvictor/5629626
	function getYoutubeId(url){
		var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
		var match = url.match(regExp);
		if(match&&match[7].length==11){ 
			return match[7];
		}
		return false;
	}



	// ----------------------------------- Start : YouTube Control
	// YouTube 控制
	// https://stackoverflow.com/a/46195259
	// 影片播放
	var domain = 'https://www.youtube.com';
	function youTubePlay(el){
		el.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', domain);
	}
	// 影片暫停
	function youTubeStop(el){
		el.contentWindow.postMessage( '{"event":"command","func":"pauseVideo","args":""}', domain);
	}
	// 影片重播
	function youTubeReplay(el){
		el.contentWindow.postMessage( '{"event":"command","func":"stopVideo","args":""}', domain);
		el.contentWindow.postMessage( '{"event":"command","func":"playVideo","args":""}', domain);
	}
	// ----------------------------------- End : YouTube Control



	// =============================================

	// 防止有瀏覽器讀不到onload
	// https://msdn.microsoft.com/en-us/windows/cc197055%28v=vs.71%29?f=255&MSPPError=-2147217396
	function windowLoadHandler(fuc){
		if ( window.addEventListener ) {
			window.addEventListener( "load", fuc, false ); 
		} else if ( window.attachEvent ) {  
			window.attachEvent( "onload", fuc ); 
		} else if ( window.onLoad ) {
			window.onload = fuc; 
		} 
	}

	// Hover 效果
	// IE 無法使用 CSS 控制 DashOffset
	// Reference https://codepen.io/thebabydino/pen/CxkHm
	var videoMask = document.querySelector('.video-mask');

	if(videoMask !== null &&  document.documentElement.browser === 'IE'){
		var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
		var cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;

        var p, offset, defaultOffset = 300;
        var defaultOffsetGoal = 150;
		var myReq;
		var getCircle = function(){
			setTimeout(function(){
                p = videoMask.querySelectorAll('circle');
                // IE 不吃 SVG CSS Transform 但吃 Attr
                for(var i = 0; i < p.length; i++) {
                    if(p[i] != undefined){
                        p[i].setAttribute('transform', 'matrix(0.7071, -0.7071, 0.7071, 0.7071, -18, 45)');
                    }
                }
                
			},1000);
		};
		windowLoadHandler(getCircle);

		var offsetMe = function() {
            if(offset < defaultOffsetGoal) return;
            for(var i = 0; i < p.length; i++) {
                p[i].style.strokeDashoffset = offset;
            }
			offset = offset - 3;
		
			myReq = requestAnimationFrame(offsetMe);
		}

		videoMask.onmouseenter = function(){
			offset = defaultOffset;
			offsetMe();
		}
		videoMask.onmouseleave = function(){
            cancelAnimationFrame(myReq);
            for(var i = 0; i < p.length; i++) {
                p[i].style.strokeDashoffset = defaultOffset;
            }
		}
	}
})(window, document);
